import * as Tone from "tone";
import { OnAnimationFrame } from "../../../animation/OnAnimationFrame";
import { HSLColor } from "../../../colors/HSLColor";
import { HTMLGradient, LinearGradient } from "../../../dom-ui/basics/Gradient";
import { BackgroundImage } from "../../../dom-ui/basics/BackgroundImage";
import { ScrollBar } from "../../../dom-ui/components/ScrollBar";
import { ScrollView } from "../../../dom-ui/components/ScrollView";
import { Rectangle } from "../../../dom-ui/graphical/Rectangle";
import { Property } from "../../../events/Property";
import { Inkscape } from "../../../svg/Inkscape";
import { Composer } from "../Composer";
import { ComposerTimeFormat, ComposerTimeFormatType } from "../time/ComposerTimeFormat";
import { Margins } from "../../../dom-ui/basics/Margins";
import { ScrollBarPositions } from "../../../dom-ui/components/ScrollViewBase";
import { Vector2 } from "three";
import { SplitView } from "../../../dom-ui/components/SplitView";
import { AutoResizeView } from "../../../dom-ui/components/AutoResizeView";
import { UIComponent } from "../../../dom-ui/components/UIComponent";
import { LinkedGraphicalElement } from "../../../dom-ui/graphical/LinkedGraphicalElement";
import { ToolBar } from "./ToolBar";
import { MainView } from "./MainView";
import { ElementType } from "../../../dom-tools/ElementType";

export class ComposerUI extends AutoResizeView
{
  static readonly elementType = new ElementType( "composer--ui" );
  verticalSplit = new SplitView();
  
  leftSplit  = new SplitView();
  rightSplit = new SplitView();
  
  mainView = new MainView();
  

  bpm = new Property<number>( 100 );
  loopStart = new Property<number>( 0 );
  loopEnd = new Property<number>( 8 );

  time = new Property<number>( 0 );

  /*
  createScrollView()
  {
    let scrollView = new ScrollView();

    let content = new Rectangle();
    let lg = LinearGradient.createVertical( new HSLColor( 230, 50, 30 ) );
    lg.position = "45deg";

    let path = "../../../_graphics/temporary/uv-map.png";
    let bgImage = BackgroundImage.create( path );
    content.background.value = bgImage + "";

    content.dimensions.set( 0, 0, 1, 1 );

    ( async ()=>
    {
      content.dimensions.size.value = await bgImage.getPixelSize();
    }
    )()


    scrollView.scrollBarPositions.value = ScrollBarPositions.BOTTOM_RIGHT;
    scrollView.scrollContainer.value.content.value = content;

    scrollView.dimensions.size.value = new Vector2( 400, 400 );

    scrollView.redraw();

    return scrollView;
  } 

  */
 

  constructor()
  {
    super( ComposerUI.elementType.create() );
    

    this.content.value = this.verticalSplit;

    this.verticalSplit.isHorizontal.value = false;

    
    this.leftSplit.views.add( new Rectangle() );
    this.leftSplit.views.add( new Rectangle() );

    this.rightSplit.views.add( new Rectangle() );
    this.rightSplit.views.add( new Rectangle() );
    


    this.leftSplit.redraw();
    this.rightSplit.redraw();

    this.verticalSplit.views.add( this.leftSplit );
    this.verticalSplit.views.add( this.mainView );
    this.verticalSplit.views.add( this.rightSplit );

    this.redraw();
    
  }

  initialize( element:Element, onAnimationFrame:OnAnimationFrame )
  {


    element.appendChild( this.element );
    onAnimationFrame.addListener( ()=> this.update() );
  };

  #addListeners()
  {
    let element = this.element as any as SVGElement;
    let composer = Composer.$;
    let bpmLayers = Inkscape.getLayers( element as SVGElement, "BPM" );

    this.bpm.addListener( 
      ()=>
      {
        bpmLayers.forEach( l => Inkscape.setText( l, this.bpm.value + "" ) );
      } 
    );

    let timeLayers = Inkscape.getLayers( element as SVGElement, "Time" );

    this.time.addListener( 
      ()=>
      {
        let timeValue = this.time.value;        

        let timeString = ComposerTimeFormat.Apply( timeValue, composer.project.settings.timeFormat );
        
        timeLayers.forEach( l => Inkscape.setText( l, timeString ) );
      } 
    );
  }

  update()
  {
    let composer = Composer.$; 

    if ( ! composer.engine.ready )
    {
      return;
    }

    this.time.value = composer.engine.currentSeconds;

    this.verticalSplit.redraw();
    this.mainView.redraw();

  }
}